﻿import React from "react";
import styles from "./styles.css";

const Loader = () => (
  <div className={styles.ldsHourglass}></div>
);

export default Loader;
